import { PropsWithChildren } from 'react'
import { DataBlockProps } from './types'
import styles from './DataBlock.module.scss'

const DataBlock = ({ label, children }: PropsWithChildren<DataBlockProps>) => (
  <div className={styles.block}>
    {label && <strong>{label}</strong>}
    {children}
  </div>
)

export default DataBlock
